var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDescargar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec0000",
    d: "M3.973 20A3.974 3.974 0 0 1 0 16.026v-2.541a.5.5 0 1 1 1 0v2.541A2.974 2.974 0 0 0 3.973 19h12.054A2.974 2.974 0 0 0 19 16.026v-2.541a.5.5 0 1 1 1 0v2.541A3.973 3.973 0 0 1 16.027 20zm5.806-5H9.75a.5.5 0 0 1-.094-.074l-3.967-3.98a.5.5 0 0 1 .707-.707l3.1 3.106V.5a.5.5 0 1 1 1 0v12.843l3.1-3.1a.5.5 0 0 1 .707.707l-3.938 3.939a.5.5 0 0 1-.587.111z",
    transform: "translate(2 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDescargar);
export default __webpack_public_path__ + "static/media/Icons_descargar.7eba2e7ed9ceaba8102e12c027aaccc2.svg";
export { ForwardRef as ReactComponent };